import { Injectable } from "@angular/core";
import { AbstractAdapter, Adapter, IAdapter } from "@app/utils/types";
import { IOrganizationShortDTO, OrganizationShortModel } from "@app/models/organization-short.model";

@Injectable({
  providedIn: "root",
})
@Adapter({ classRef: OrganizationShortModel })
export class OrganizationShortAdapter
  extends AbstractAdapter<IOrganizationShortDTO, OrganizationShortModel>
  implements IAdapter<IOrganizationShortDTO, OrganizationShortModel> {}
